/**
 * promptr.ts - Promptr (Dialogs & Prompts) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1540 [pending] danielbeer: Initial creation
 */

export const promtrModule = {
  id: 'ui-promptr',
  name: 'Dialogs & Prompts',
  icon: '💬',
  category: 'modules',
  order: 12,
  
  // Package metadata for info panel
  packageInfo: {
    name: '@opcentral/promptr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Universal dialog and prompt system for OpCentral',
    status: 'implemented',
    implementationProgress: 90,
    dependencies: {
      '@opcentral/core': '*',
      'react': '^18.0.0'
    },
    keywords: ['dialogs', 'modals', 'prompts', 'alerts', 'ui'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    animateDialogs: {
      type: 'boolean',
      label: 'Animate Dialogs',
      description: 'Show smooth transitions for dialogs',
      defaultValue: true
    },
    
    closeOnEscape: {
      type: 'boolean',
      label: 'Close on Escape',
      description: 'Allow ESC key to close dialogs',
      defaultValue: true
    },
    
    closeOnBackdropClick: {
      type: 'boolean',
      label: 'Close on Backdrop Click',
      description: 'Close dialog when clicking outside',
      defaultValue: true
    },
    
    defaultDialogSize: {
      type: 'select',
      label: 'Default Dialog Size',
      description: 'Default size for dialogs',
      defaultValue: 'medium',
      options: [
        { label: 'Small', value: 'small' },
        { label: 'Medium', value: 'medium' },
        { label: 'Large', value: 'large' },
        { label: 'Extra Large', value: 'xlarge' }
      ]
    },
    
    confirmDestructiveActions: {
      type: 'boolean',
      label: 'Confirm Destructive Actions',
      description: 'Show confirmation for delete/remove actions',
      defaultValue: true
    }
  }
};

export default promtrModule;
